function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavourites({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 6.37468C12.7618 5.41409 13.8945 4.86411 15.0848 4.87693C17.7276 4.87693 19.5033 7.48551 19.5033 9.91465C19.5033 14.9926 13.4825 18.8828 12.0002 18.8828C10.5179 18.8828 4.49707 14.9926 4.49707 9.91465C4.49707 7.48551 6.27281 4.87693 8.91558 4.87693C10.1059 4.86411 11.2386 5.41409 12.0002 6.37468Z",
    stroke: "#8A90A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "inherit"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourites);
export default __webpack_public_path__ + "static/media/favourites.fd2b90d76d9889ecf0a4f4d2db3bbe91.svg";
export { ForwardRef as ReactComponent };